import { observer } from 'mobx-react-lite';
import React, { FC} from 'react';


const ProfessionsAtlas: FC<any> = (() => {

    return (
        <div className="w-100 h-100 p-0 position-relative end-0">
            <iframe src="https://atlas100.ru/catalog/" title="atlas100" className="w-100 h-100 border-0"/>
        </div>
    )
});

export default observer(ProfessionsAtlas);